/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GssOccasionPeopleResponse } from './gssOccasionPeopleResponse';

export type GenericApiResponseGssOccasionPeopleResponseData = GssOccasionPeopleResponse | null;
